export default "__VITE_ASSET__CQ8QXXzd__"